var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 153 64",
    style: {
      enableBackground: "new 0 0 153 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E74421;}\n\t.st1{fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st0",
    d: "M144.3,27.1c-0.8,0-1.6-0.3-2.1-0.5c-9.5-5-20.3-7.9-30.8-7.9c-1.3,0-2.3,0.1-3.5,0.2 c2,3.1,5.4,7.7,7.7,10.5c0.6,0.7,0.8,1.2,0.8,1.9c0,1.2-1.3,2.4-2.7,2.4c-0.9,0-1.5-0.4-2.3-1.4c-2.8-3.3-7.1-9.3-9.1-12.6 c-10,1.8-21.1,7.6-27.6,12.8c-0.8,0.6-1.3,0.9-2,0.9c-1.4,0-2.6-1.2-2.6-2.6c0-0.8,0.3-1.4,1.3-2.2c10-8.3,25.6-14.9,38.8-14.9 c5.2,0,10.3,0.7,15.2,1.9c3,0.7,7.4,2.2,11.1,3.8C126.6,13.5,114.3,8,106.5,8c-2,0-3.2,0.7-3.2,2c0,0.8,0.4,1.8,1.1,2.9 c-1.6,0.2-3.6,0.5-5.2,0.9c-0.8-1.5-1.4-3.1-1.4-4.8c0-3.8,2.5-6.1,7.5-6.1c11.3,0,30.3,10.5,39.7,18.2c1.1,0.9,2.2,2,2.2,3.3 C147.2,25.6,146.1,27.1,144.3,27.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st1",
    d: "M21.7,49.5c0-0.7,0.4-1.1,1-1.1c0.6,0,1,0.4,1,1.1v1.1c0.6-1.1,1.8-2.2,2.9-2.2 c0.7,0,1,0.4,1,1c0,0.5-0.3,0.9-1.2,1.2c-1.9,0.5-2.7,1.6-2.7,3.6V60c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.4-1-1.1V49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st1",
    d: "M68,49.5c0-0.7,0.4-1.1,1-1.1c0.6,0,1,0.4,1,1.1v1.1c0.6-1.1,1.8-2.2,2.9-2.2c0.7,0,1,0.4,1,1 c0,0.5-0.3,0.9-1.2,1.2c-1.9,0.5-2.7,1.6-2.7,3.6V60c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.4-1-1.1V49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st1",
    d: "M33.5,48.4c2,0,3.3,0.8,3.3,1.5c0,0.4-0.3,0.9-0.8,0.9c-0.8,0-1.1-0.6-2.5-0.6 c-2.3,0-3.5,2.1-3.5,4.5c0,2.7,1.4,4.5,3.5,4.5c1.5,0,1.9-0.6,2.6-0.6c0.5,0,0.7,0.3,0.7,0.8c0,0.5-0.4,0.8-1.1,1.2 c-0.6,0.3-1.4,0.5-2.2,0.5c-3.5,0-5.6-2.6-5.6-6.3C27.9,51.1,30,48.4,33.5,48.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    className: "st1",
    d: "M46.6,54c0-1.8-1-3.8-3.3-3.8c-2.2,0-3.4,1.7-3.5,3.8H46.6z M39.9,55.5c0,2,1.4,3.8,3.7,3.8 c2.4,0,3-1.4,3.9-1.4c0.5,0,0.8,0.3,0.8,0.9c0,1-2.2,2.3-4.7,2.3c-1.9,0-3.1-0.6-4-1.5c-1.2-1.2-1.7-3-1.7-4.8 c0-3.4,2.1-6.3,5.6-6.3c3.2,0,5.3,2.9,5.3,6c0,0.7-0.3,1.1-1.1,1.1H39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    className: "st1",
    d: "M52.9,60c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.4-1-1.1V45.3c0-0.7,0.4-1.1,1-1.1c0.6,0,1,0.4,1,1.1 V60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st1",
    d: "M60.4,59.3c2,0,3.4-1.8,3.4-4.5c0-2.8-1.4-4.5-3.4-4.5c-2,0-3.4,1.8-3.4,4.5 C57.1,57.5,58.4,59.3,60.4,59.3 M60.4,61.1c-3.3,0-5.5-2.6-5.5-6.4c0-3.7,2.2-6.4,5.5-6.4c3.3,0,5.5,2.6,5.5,6.4 C65.9,58.5,63.7,61.1,60.4,61.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st1",
    d: "M88.3,49.2c-1.2,4-3,10.5-3.2,11c-0.2,0.6-0.5,0.8-1.1,0.8c-0.6,0-0.9-0.2-1.1-0.8 c-0.2-0.6-2.1-7.4-3.3-11.3c-0.2-0.6-0.4-1.4-0.5-2.1c-0.1,0.6-0.2,1.4-0.3,2.1c-0.6,3.7-1.5,9.5-1.8,11.1c-0.1,0.7-0.5,1-1.1,1 c-0.6,0-0.9-0.4-0.9-1c0-0.2,0-0.5,0.1-0.9c0,0,2.1-12.5,2.2-13.4c0.2-1,0.7-1.6,1.6-1.6c0.8,0,1.4,0.4,1.6,1.3 c0.2,0.5,1.8,6.4,2.9,10.1c0.2,0.7,0.4,1.5,0.5,2.2c0.1-0.7,0.3-1.5,0.5-2.1c1.1-3.7,2.8-9.6,2.9-10.1c0.2-0.8,0.8-1.3,1.5-1.3 c0.8,0,1.4,0.5,1.6,1.6c0.1,1,2.2,13.4,2.2,13.4c0.1,0.4,0.1,0.7,0.1,0.9c0,0.6-0.4,1-0.9,1c-0.6,0-1-0.3-1.1-1 c-0.2-1.6-1.1-7.1-1.7-10.8c-0.1-0.8-0.2-1.6-0.3-2.4C88.7,47.6,88.5,48.4,88.3,49.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st1",
    d: "M97.6,49.5c0-0.7-0.4-1.1-1-1.1c-0.6,0-1,0.4-1,1.1V60c0,0.7,0.4,1.1,1,1.1c0.6,0,1-0.4,1-1.1 V49.5z M96.5,44.8c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3C95.3,45.3,95.8,44.8,96.5,44.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st1",
    d: "M101.2,45.8c0-0.7,0.4-1.1,1-1.1c0.6,0,1,0.4,1,1.1v2.7h0.8c0.7,0,1,0.3,1,0.9 c0,0.6-0.4,0.9-1,0.9h-0.8V60c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.4-1-1.1v-9.7h-0.8c-0.7,0-1-0.3-1-0.9c0-0.6,0.4-0.9,1-0.9h0.8V45.8z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st1",
    d: "M107.7,45.8c0-0.7,0.4-1.1,1-1.1c0.6,0,1,0.4,1,1.1v2.7h0.8c0.7,0,1,0.3,1,0.9 c0,0.6-0.3,0.9-1,0.9h-0.8V60c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.4-1-1.1v-9.7h-0.8c-0.7,0-1-0.3-1-0.9c0-0.6,0.4-0.9,1-0.9h0.8V45.8z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st1",
    d: "M9.9,54.6c0.9-2.4,1.8-5,2.4-6.8c0.2-0.5,0.3-1,0.4-1.3c0.1,0.4,0.3,0.9,0.4,1.3 c0.6,1.8,1.6,4.4,2.4,6.8H9.9z M19.5,59.2C19,58,15,47.2,14.4,45.5c-0.3-0.8-0.8-1.3-1.6-1.3c-0.8,0-1.3,0.5-1.6,1.3 C10.9,46.3,6.5,58,6.1,59.2c-0.2,0.5-0.3,0.8-0.3,1c0,0.5,0.4,0.9,1,0.9c0.6,0,0.9-0.3,1-0.8c0.1-0.3,0.7-1.9,1.4-3.9h7 c0.7,1.9,1.2,3.5,1.4,3.9c0.2,0.4,0.4,0.8,1,0.8c0.5,0,1-0.3,1-0.9C19.7,60,19.7,59.8,19.5,59.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st1",
    d: "M128.5,60c0,0.7-0.4,1.1-1,1.1c-0.6,0-1-0.4-1-1.1V45.3c0-0.7,0.4-1.1,1-1.1c0.6,0,1,0.4,1,1.1 V60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st1",
    d: "M118.1,59.3c-2,0-3.4-1.8-3.4-4.6c0-2.8,1.4-4.5,3.4-4.5c2,0,3.4,1.8,3.4,4.5 C121.4,57.5,120.1,59.3,118.1,59.3 M122.5,48.4c-0.6,0-1,0.4-1,1.1v0.9c-0.8-1.3-2-2-3.5-2c-3.1,0-5.3,2.6-5.3,6.4 c0,3.7,2.2,6.4,5.3,6.4c1.5,0,2.8-0.8,3.5-2V60c0,0.7,0.4,1.1,1,1.1c0.6,0,1-0.4,1-1.1V49.5C123.5,48.8,123.1,48.4,122.5,48.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoLight);
export default __webpack_public_path__ + "static/media/company-logo-light.53cde533a2da70a9328b4dfe84098965.svg";
export { ForwardRef as ReactComponent };